import React, { useEffect } from 'react';
import { defaultTimeProps } from '@constants';
import { DOMAIN_CLASS } from '@enums';
import { useStore } from '@hooks';
import { Loader } from '@ui';
import { observer } from 'mobx-react';
import { PERFORMANCE_METRICS } from '../../../Performance/constants';
import { StyledLoaderWrapper } from '../../styled';
import Connected from '../Connected';

const BigCommerce = observer(() => {
    const date = defaultTimeProps;
    const store = useStore();
    const { firstName, lastName } = store.authStore;
    const { currentAccount, getCurrentAccount, pending } = store.accountsStore;
    const { performanceList, pendingMetricsOverview, getMetricsOverview } = store.performanceStore;
    const shopDomain = currentAccount?.domains?.find(
        (domain) => domain.class === DOMAIN_CLASS.MAIN_ECOMMERCE
    )?.shopDomain;

    const defaultProps = {
        ...date
    };

    useEffect(() => {
        (async () => {
            await getCurrentAccount();
        })();
    }, [pending]);

    useEffect(() => {
        getMetricsOverview({
            metrics: PERFORMANCE_METRICS,
            ...defaultProps
        });
    }, []);

    if (pending) {
        return (
            <StyledLoaderWrapper>
                <Loader size='120px' />
            </StyledLoaderWrapper>
        );
    }

    return (
        <Connected
            lastName={lastName}
            pendingMetricsOverview={pendingMetricsOverview}
            shopDomain={shopDomain}
            performanceList={performanceList}
            firstName={firstName}
        />
    );
});

export default BigCommerce;
